<template>
    <div class="opera-account">
        <topNav :title="$t('account_title')" url='/opera/setting'></topNav>
        <ul class="perInfo">
          <!--字典项中文参数 用户名 -->
          <mt-cell :title="$t('code')" :value="perInfo.code"></mt-cell>
          <!--字典项中文参数 集团名称 -->
          <mt-cell :title="$t('hotelGroupName')" :value="perInfo.hotelGroupName"></mt-cell>
          <!--字典项中文参数 酒店名称 -->
          <mt-cell :title="$t('hotelName')" :value="perInfo.hotelName" class="split"></mt-cell>
          <!--字典项中文参数 手势密码 手势密码仅本机有效-->
          <mt-cell :title="$t('account_lockerTip')" :label="$t('account_lockerTip_label')" :value="lockerTip" is-link
                   to="/opera/accountLocker" class="split topcell"></mt-cell>
          <!--字典项中文参数 上次登录时间-->
          <mt-cell :title="$t('lastLoginDate')" :value="perInfo.lastLoginDate" class="topcell"></mt-cell>
          <!--字典项中文参数 上次登录Ip-->
          <mt-cell :title="$t('lastIp')" class="split" :value="perInfo.lastIp"></mt-cell>
        </ul>
          <div class="tip">{{$t('account_tip')}}</div>
    </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      perInfo: {},
      lockerTip: ""
    };
  },
  mounted() {
    this.lockerTip = this.$t("account_lockerTip_sta_1");
    this.$http.post("/mobilepmsapi/sys/getUserInfo").then(res => {
      if (res.data.result == 0) {
        this.perInfo = res.data.retVal;
      }
    });
    this.getlocker();
  },
  methods: {
    getlocker() {
     var store = this.$isApp?plus.storage:localStorage;
      if (
        store.getItem("accountlocker") != null &&
        store.getItem("accountlocker") == "2"
      ) {
        this.lockerTip = this.$t("account_lockerTip_sta_2");
      }
    }
  }
};
</script>
<style lang='less'>
.opera-account {
  background-color: #f7f8fa;
  .perInfo {
    margin-top: 0.4rem;
    overflow: hidden;
  }
  .split {
    background-image: linear-gradient(
      0deg,
      #d9d9d9,
      #d9d9d9 50%,
      transparent 50%
    );
    background-size: 100% 1px;
    background-repeat: no-repeat;
    background-position: bottom;
    margin-bottom: 0.8rem;
  }
  .topcell {
    .mint-cell-wrapper {
      background-origin: border-box;
    }
  }
  .tip {
    width: 96%;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.34rem;
    margin-left: 0.2rem;
    color: #c0c0c0;
  }
}
</style>



// WEBPACK FOOTER //
// account.vue?8e8aeda4